import { FC, useState } from 'react';
import { IoHomeOutline } from 'react-icons/io5';
import { IoMdArrowDropdown } from 'react-icons/io';
import { useDefaultColorValue } from 'services/queries/app';
import { useAppContext } from 'provider/AppProvider/AppProvider';
import { ISubmenuProps } from '../Navbar.interface';
import { StyledNavbar } from '../Navbar.styles';

export interface IMenuItemProps {
  label: string;
  url: string;
  submenu: ISubmenuProps[];
  handleCloseNavbar: () => void;
}

const MenuItem: FC<IMenuItemProps> = ({
  label,
  url,
  submenu,
  handleCloseNavbar,
}) => {
  const { baseURL } = useAppContext();
  const hasSubmenu = submenu && submenu.length > 0;
  const colors = useDefaultColorValue();
  const [svgColor, setSvgColor] = useState(colors.dark);
  const [hoveringIndex, setHoveringIndex] = useState<number | null>(null);

  return (
    <li className="relative group nav-item">
      <StyledNavbar
        colors={colors}
        className="px-3 py-2 flex items-center gap-1 uppercase font-semibold text-[24px] lg:text-[22px] leading-snug"
        to={`${String(baseURL)}${url}`}
      >
        {label === 'Home' ? (
          <div className="flex items-center justify-center cursor-pointer">
            <IoHomeOutline
              size={32}
              color={svgColor}
              onMouseEnter={() => setSvgColor(colors.medium)}
              onMouseLeave={() => setSvgColor(colors.dark)}
              onClick={handleCloseNavbar}
            />
          </div>
        ) : (
          <>
            <span className="ml-2 whitespace-nowrap">{label}</span>
            {hasSubmenu && <IoMdArrowDropdown size={24} className="block" />}
          </>
        )}
      </StyledNavbar>
      {hasSubmenu && (
        <div
          className="absolute top-full lg:left-1/2 lg:-translate-x-1/2 hidden group-hover:block z-50 w-auto min-w-[200px] max-w-[260px]"
          style={{ display: 'none' }}
        >
          <ul className="flex flex-col shadow-lg rounded-b-md w-full">
            {submenu.slice(0, 5).map((item, index) => (
              <li
                key={item.url}
                className="px-4 py-2 whitespace-nowrap uppercase hover:underline text-white"
                onMouseEnter={() => setHoveringIndex(index)}
                onMouseLeave={() => setHoveringIndex(null)}
                style={{
                  backgroundColor:
                    hoveringIndex === index ? colors.medium : colors.dark,
                }}
              >
                <StyledNavbar
                  colors={colors}
                  to={`${String(baseURL)}${String(item?.url ?? '')}`}
                  className="block w-full whitespace-normal break-words leading-snug text-white"
                  onClick={handleCloseNavbar}
                >
                  {item.label}
                </StyledNavbar>
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  );
};

export default MenuItem;
